import AlertComponent from './alert'
const Alert = {
    install(Vue){
        const alertChild = Vue.extend(AlertComponent)
        let instance = new alertChild()
        instance.$mount(document.createElement('div'))
        document.body.append(instance.$el)
        Vue.prototype.$alert = (text,func,title)=>{
            instance.showFlag = true
            instance.title = title||'提示'
            instance.text = text
            instance.method = func
        }
    }   
}
export default Alert